module.exports = __webpack_public_path__ + "static/media/2023_51.85ce5bb0.jpg";